module.exports = __webpack_public_path__ + "static/media/escola-libras.203f0aa5.jpg";